import { useState, useRef } from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
// import axios from "axios";
import NotFound from "./NotFound";

import Header from "../components/Header/Header";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

import TableApprover from "../components/Table/TableApprover";
import Dashboard from "../components/Dashboard/Dashboard";
import Footer from "../components/Footer/Footer";
import FeeTypeDropdown from "../components/FeeTypeDropdown/FeeTypeDropdown";
import { useSidebarContext } from "../components/Sidebar/context/SidebarState";
import CheckerDashboard from "../components/Dashboard/ApproverDashboard";
import ApproverDashboard from "../components/Dashboard/ApproverDashboard";

import toWords from "num-words";

import UploadFileIcon from "@mui/icons-material/UploadFile";
import { ListItemIcon } from "@mui/material";

const ApproverPage = () => {
  const {
    isMoreSidebar,

    setShowDashboard,
    showDashboard,
    sidebarText,
  } = useSidebarContext();

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const [fileName, setFileName] = useState("No file");

  const formContainerRef = useRef(null);
  const location = useLocation();
  const {
    userId = null,
    distId,
    userName: checkerName,
  } = location.state ? location.state : {};

  const [statusArray, setStatusArray] = useState([]);

  const [selectedFile, setSelectedFile] = useState(null);

  console.log(showDashboard, "1");

  const [curStatus, setCurStatus] = useState("");

  const [TDSValue, setTdsValue] = useState("");
  const [GSTValue, setGstValue] = useState("");
  const [FEEValues, setFeeValues] = useState([]);
  const [distributorNameInput, setDistributorNameInput] = useState("");
  const [relatedDetails, setRelatedDetails] = useState([]);
  const [fundNameInput, setFundNameInput] = useState("");
  const [relatedFunds, setFundDetails] = useState([]);

  const [tableData, setTableData] = useState([]);

  const [rowId, setRowId] = useState("");
  const [rowStatus, setRowStatus] = useState("");
  const [rowStatusId, setRowStatusId] = useState("");
  const [remarks, setRemarks] = useState("");

  const [basicAmountInWords, setBasicAmountInWords] = useState("");
  const [totalAmountInWords, setTotalAmountInWords] = useState("");

  const [month, setMonth] = useState("");

  const [selectedRows, setSelectedRows] = useState([]);

  const [filter, setFilter] = useState("");

  const [selectedRowIds, setSelectedRowIds] = useState([]);

  // const [showDashboard, setShowDashboard] = useState(true);
  const [feeTypes, setFeeTypes] = useState([]);

  const baseUrl = process.env.REACT_APP_SERVER_BASE_URL;

  useEffect(() => {
    const fetchFeeTypes = async () => {
      try {
        const response = await axios.get(`${baseUrl}/fee-types`);
        console.log(response.data);
        setFeeTypes(response.data);
        console.log(feeTypes, "128");
      } catch (error) {
        console.error("Error fetching fee types:", error.message);
      }
    };
    fetchFeeTypes();
  }, []);

  useEffect(() => {
    setFeeValues([]);
    setSelectedRowIds([]);
    setSelectedRows([]);
    setMonth("");
    setTdsValue("");
    setGstValue("");
    setFundNameInput("");
    setRowStatus("");
    setRowStatusId("");
  }, [showDashboard]);

  useEffect(() => {
    const fetchBrokerageDetails = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/get-brokerages-for-app?page=${currentPage}&limit=${rowsPerPage}&statusFilter=${curStatus}&filter=${filter}`
        );
        // Initialize status for each row
        const data = response.data;
        console.log(response.data, "26");
        setTotalPages(response?.data?.totalCount);
        setTableData(response?.data?.data);
        console.log(checkerName, "checkername");
      } catch (error) {
        console.error("Error retrieving brokerage details:", error.message);
      }
    };
    fetchBrokerageDetails();
    // const intervalId = setInterval(fetchBrokerageDetails,10000);
    // return () => clearInterval(intervalId);
  }, [currentPage, rowsPerPage, baseUrl, curStatus, filter]);

  const fetchGstCategories = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/status-categories?userId=${userId}`
      );
      setStatusArray(response.data);
    } catch (error) {
      console.error("Error fetching GST categories:", error.message);
    }
  };

  useEffect(() => {
    fetchGstCategories();
    // fetchTdsCategories();
  }, []);

  if (userId === null) {
    return <NotFound />;
  }

  const clearAllFields = () => {
    formContainerRef.current.style.display = "none";
    setRowStatusId("");
    setSelectedRowIds([]);
    setSelectedRows([]);
    setBasicAmountInWords("");
    setTotalAmountInWords("");
    document.getElementById("dist-name").value = "";
    document.getElementById("select-fund").value = "";
    document.getElementById("invoice-date").value = "";
    setSelectedFile(null);
    document.getElementById("amnt").value = "";
    document.getElementById("total").value = "";
    setDistributorNameInput("");
    setFundNameInput("");
    // document.getElementById("upload-file").value="";
    document.getElementById("fee-type").value = "";
    setRemarks("");
    setGstValue("");
    setTdsValue("");
    setFeeValues([]);
    setMonth(null);
    document.getElementById("recentremarks").value = "";
    document.getElementById("remarks").value = "";
  };

  const handleRowClick = async (rowData) => {
    console.log(rowData, "71");

    if (rowData.statusId === 2 || rowData.statusId === 4) {
      console.log(rowData, "1");
      formContainerRef.current.style.display = "grid";
      // formContainerRef.current.scrollIntoView({ behavior: "auto" });
      // formContainerRef.current.focus();

      const updatedSelectedRows = selectedRowIds.includes(rowData.id)
        ? selectedRowIds.filter((id) => id !== rowData.id)
        : [...selectedRowIds, rowData.id];

      setSelectedRowIds(updatedSelectedRows);

      console.log(selectedRowIds, "102");

      // Populate input fields with row data
      document.getElementById("dist-name").value = rowData.distributorName;
      console.log(rowData, "name");

      // Handle file upload if needed

      setSelectedFile(rowData.brokerageFile);
      setFileName(rowData.brokerageFileRow.fileName);
      document.getElementById("amnt").value = rowData.basicAmount;
      console.log(rowData, "amnt");

      const feeCheckboxes = document.querySelectorAll(
        '#fee-type input[type="checkbox"]'
      );

      feeCheckboxes.forEach((checkbox) => {
        if (rowData.feeTypeCode.includes(checkbox.value)) {
          checkbox.checked = true;
        } else {
          checkbox.checked = false;
        }
      });

      if (rowData.invoiceMonth) {
        console.log(rowData.invoiceMonth);
        setMonth(rowData.invoiceMonth);
      }

      document.getElementById("recentremarks").value =
        rowData.userremarks || rowData.checkerRemarks || "";
      console.log(rowData, "remmarks");

      const basicAmount =
        typeof rowData.basicAmount === "number"
          ? rowData.basicAmount
          : parseFloat(rowData.basicAmount);
      const totalAmount =
        typeof rowData.totalAmount === "number"
          ? rowData.totalAmount
          : parseFloat(rowData.totalAmount);

      // Ensure that the amounts are valid numbers before using toFixed
      if (!isNaN(basicAmount)) {
        setBasicAmountInWords(toWords(basicAmount.toFixed(0)));
      } else {
        console.error(
          "basicAmount is not a valid number:",
          rowData.basicAmount
        );
      }

      if (!isNaN(totalAmount)) {
        setTotalAmountInWords(toWords(totalAmount.toFixed(0)));
      } else {
        console.error(
          "basicAmount is not a valid number:",
          rowData.basicAmount
        );
      }

      setDistributorNameInput(rowData.distributorName);
      setFundNameInput(rowData.fundName);
      document.getElementById("total").value = rowData.totalAmount;

      setRowId(rowData.id);
      setRowStatus(rowData.statusName);
      setRowStatusId(rowData.statusId);

      setTdsValue(rowData.tdcCategoryCode);
      console.log(rowData.gstCategoryCode, "494");
      setGstValue(rowData.gstCategoryCode);
      console.log(rowData.feeTypeCode, "494");
      setFeeValues([...rowData.feeTypeCode]);
    } else {
      formContainerRef.current.style.display = "none";
      setRowId("");
      setRowStatus("");
      setRowStatusId(); //-------------------
      console.log(rowStatus, "116");
      setBasicAmountInWords("");
      setTotalAmountInWords("");
    }
    // todo for recieved  to maker by distribuor

    // Handle row click in the child component
  };

  const handleRemarks = (e) => {
    setRemarks(e.target.value);
  };

  const handleAction = async (action) => {
    console.log(selectedRowIds, "178");
    // return;
    if (selectedRowIds.length === 0) {
      alert("Please select rows first");
      return;
    }

    if (rowId === "") {
      alert("Please select a row first");
      return;
    }
    if (
      (action === "reject" || action === "modify") &&
      selectedRowIds.length > 1
    ) {
      alert(
        "Please select only one row at a time for rejection or modifications"
      );
      return;
    }
    const loader = document.getElementById("loader");
    loader.style.display = "block"; // Show loader
    setTimeout(async function () {
      // Your actual functionality here
      // For demonstration, I'm just delaying the hiding of the loader after 3 seconds

      // Hide loader

      try {
        const response = await axios.post(`${baseUrl}/checker-action`, {
          selectedRowIds: selectedRowIds,
          remarks: remarks,
          action: action,
          userId,
          checkerName,
          rowStatus,
          rowStatusId,
        });
        console.log(response.data); // Handle response data from backend if needed
        // setShowRemarksBox(false);
        // Update the status of the selected row
        // const updatedData = tableData.map((row) => {
        //   if (selectedRowIds.includes(row.id)) {
        //     return { ...row, statusName: response.data.message };
        //   }
        //   return row;
        // });
        // setTableData(updatedData);
        setRowStatus("");

        setSelectedRows([]);
        setSelectedRowIds([]);
        toast.success("Completed successfully.");
        console.log("Data updated successfully:", response.data);

        clearAllFields();
        // Disable the selected row
      } catch (error) {
        console.error("Error modifying:", error.message);
        // Handle error
      }
      loader.style.display = "none";
    }, 4000);
  };

  const handleDownloadFile = async (filePath) => {
    try {
      // Make a GET request to download the file
      const response = await axios.get(
        `${baseUrl}/download-file?filePath=${filePath}&user=${userId}`,
        {
          responseType: "blob", // Set the response type to blob
        }
      );
      // Create a URL for the downloaded file
      const url = window.URL.createObjectURL(new Blob([response.data]));
      // Create a temporary link element
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filePath.split("/").pop()); // Set the filename
      // Simulate a click on the link to trigger the download
      document.body.appendChild(link);
      link.click();
      // Clean up
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error downloading file:", error.message);
    }
  };

  const iconStyle = {
    fontSize: "1.4rem", // Adjust the size as needed
    color: "#429cb6",
  };
  return (
    <>
      <Header
        text={["Transcation", "Reports"]}
        userId={userId}
        userName={checkerName}
        setShowDashboard={setShowDashboard}
        showDashboard={showDashboard}
      />
      <div id="loader" style={{ display: "none" }}></div>

      <div
        style={{
          marginLeft: "5px",
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        {showDashboard ? (
          <ApproverDashboard
            setShowDashboard={setShowDashboard}
            setCurStatus={setCurStatus}
            userId={userId}
            setFilter={setFilter}
          />
        ) : (
          <div style={{ flex: 1 }}>
            <div
              style={{
                padding: "20px 20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span
                style={{ color: "black", fontWeight: "600", fontSize: "1rem" }}
              >
                Distributor Brokerage
              </span>
            </div>

            <div
              ref={formContainerRef}
              className="distribution-brokerage-main cust-shadow rounded-md"
            >
              <div
                style={{
                  border: "1px solid #6e3289",
                  padding: "10px",
                  borderRadius: "8px",
                  width: "80%",
                  margin: "0 auto",
                }}
              >
                {/* <form action="" onSubmit={(e) => e.preventDefault()}> */}
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                      gap: "20px",
                    }}
                  >
                    <div>
                      <label
                        htmlFor="dist-name"
                        style={{
                          fontWeight: "bold",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        Distributor Name:
                      </label>
                      <input
                        type="text"
                        id="dist-name"
                        style={{
                          width: "100%",
                          padding: "10px",
                          border: "1px solid #D9D9D9",
                          borderRadius: "6px",
                          fontSize: "14px",
                          marginBottom: "5px !important",
                        }}
                        disabled
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="select-fund"
                        style={{
                          fontWeight: "bold",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        Fund Name:
                      </label>
                      <input
                        type="text"
                        id="select-fund"
                        disabled
                        value={fundNameInput}
                        style={{
                          width: "100%",
                          padding: "10px",
                          border: "1px solid #D9D9D9",
                          borderRadius: "6px",
                          fontSize: "14px",
                          marginBottom: "5px !important",
                        }}
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="invoice-date"
                        style={{
                          fontWeight: "bold",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        Invoice Month:
                      </label>
                      <input
                        type="date"
                        id="invoice-date"
                        name="startDate"
                        disabled
                        value={month}
                        style={{
                          width: "100%",
                          padding: "10px",
                          border: "1px solid #D9D9D9",
                          borderRadius: "6px",
                          fontSize: "14px",
                          marginBottom: "5px !important",
                        }}
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="upload-file"
                        style={{
                          fontWeight: "bold",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        Calculation File:
                      </label>
                      <input
                        // className="file-input"
                        id="upload-file"
                        type="file"
                        name="upload-file"
                        disabled
                        style={{
                          width: "100%",
                          padding: "10px",
                          border: "1px solid #D9D9D9",
                          borderRadius: "6px",
                          fontSize: "14px",
                          marginBottom: "5px !important",
                        }}
                      />
                      <label
                        htmlFor="upload-file"
                        style={{
                          fontWeight: "bold",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        <span className="file-name">{fileName}</span>
                      </label>
                    </div>
                    <div>
                      <label
                        htmlFor="amnt"
                        style={{
                          fontWeight: "bold",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        Basic Amount:
                      </label>
                      <input
                        type="number"
                        id="amnt"
                        name="amnt"
                        disabled
                        style={{
                          width: "100%",
                          padding: "10px",
                          border: "1px solid #D9D9D9",
                          borderRadius: "6px",
                          fontSize: "14px",
                          marginBottom: "5px !important",
                        }}
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="amnt"
                        style={{
                          fontWeight: "bold",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        Basic Amount:
                      </label>
                      <input
                        type="number"
                        id="amnt"
                        name="amnt"
                        disabled
                        style={{
                          width: "100%",
                          padding: "10px",
                          border: "1px solid #D9D9D9",
                          borderRadius: "6px",
                          fontSize: "14px",
                          marginBottom: "5px !important",
                        }}
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="amnt-in"
                        style={{
                          fontWeight: "bold",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        Basic Amount in Words:
                      </label>
                      <input
                        type="text"
                        id="amnt-in"
                        name="amnt"
                        value={basicAmountInWords}
                        disabled
                        style={{
                          width: "100%",
                          padding: "10px",
                          border: "1px solid #D9D9D9",
                          borderRadius: "6px",
                          fontSize: "14px",
                          marginBottom: "5px !important",
                        }}
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="amnt-in"
                        style={{
                          fontWeight: "bold",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        Basic Amount in Words:
                      </label>
                      <input
                        type="text"
                        id="amnt-in"
                        name="amnt"
                        value={basicAmountInWords}
                        disabled
                        style={{
                          width: "100%",
                          padding: "10px",
                          border: "1px solid #D9D9D9",
                          borderRadius: "6px",
                          fontSize: "14px",
                          marginBottom: "5px !important",
                        }}
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="gst"
                        style={{
                          fontWeight: "bold",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        GST Category:
                      </label>
                      <input
                        id="gst"
                        name="gstCat"
                        disabled
                        value={GSTValue}
                        style={{
                          width: "100%",
                          padding: "10px",
                          border: "1px solid #D9D9D9",
                          borderRadius: "6px",
                          fontSize: "14px",
                          marginBottom: "5px !important",
                        }}
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="tds"
                        style={{
                          fontWeight: "bold",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        TDS Category:
                      </label>
                      <input
                        id="tds"
                        name="tdsCat"
                        disabled
                        value={TDSValue}
                        style={{
                          width: "100%",
                          padding: "10px",
                          border: "1px solid #D9D9D9",
                          borderRadius: "6px",
                          fontSize: "14px",
                          marginBottom: "5px !important",
                        }}
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="total"
                        style={{
                          fontWeight: "bold",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        Total Amount:
                      </label>
                      <input
                        type="number"
                        id="total"
                        name="total"
                        disabled
                        style={{
                          width: "100%",
                          padding: "10px",
                          border: "1px solid #D9D9D9",
                          borderRadius: "6px",
                          fontSize: "14px",
                          marginBottom: "5px !important",
                        }}
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="total-in"
                        style={{
                          fontWeight: "bold",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        Total Amount in Words:
                      </label>
                      <input
                        type="text"
                        id="total-in"
                        name="total"
                        value={totalAmountInWords}
                        readonly
                        disabled
                        style={{
                          width: "100%",
                          padding: "10px",
                          border: "1px solid #D9D9D9",
                          borderRadius: "6px",
                          fontSize: "14px",
                          marginBottom: "5px !important",
                        }}
                      />
                    </div>
                    <div>
                      <FeeTypeDropdown
                        feeTypes={feeTypes}
                        FEEValues={FEEValues}
                        // handleFeeChange={handleFeeChange}
                        disableFields={true}
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="recentremarks"
                        style={{
                          fontWeight: "bold",
                          marginBottom: "5px",
                          display: "block",
                        }}
                      >
                        Recent Remarks:
                      </label>
                      <textarea
                        rows="5"
                        cols="32"
                        id="recentremarks"
                        disabled
                        style={{
                          width: "100%",
                          padding: "10px",
                          border: "1px solid #D9D9D9",
                          borderRadius: "6px",
                          fontSize: "14px",
                          marginBottom: "5px !important",
                        }}
                      />
                    </div>
                    <div>
                      <label htmlFor="remarks">Remarks:</label>
                      <textarea
                        rows="5"
                        cols="32"
                        id="remarks"
                        onChange={handleRemarks}
                        style={{
                          width: "100%",
                          padding: "10px",
                          border: "1px solid #D9D9D9",
                          borderRadius: "6px",
                          fontSize: "14px",
                          marginBottom: "5px !important",
                        }}
                      />
                    </div>
                    <div></div>
                    {rowId &&
                      (rowStatusId === 2 || rowStatusId === 4) &&
                      selectedRowIds.length > 0 && (
                        // <div style={{ padding: "20px", border: "1px solid #ccc", marginBottom: "20px",marginTop:"20px", textAlign:"center"}}>

                        <div
                          className="approve-btns"
                          style={{ marginBottom: "40px", gridColumn: "span 2", display: 'flex', justifyContent: "center" }}
                          
                        >
                          <button onClick={() => handleAction("approve")}>
                            Approve
                          </button>
                          <button onClick={() => handleAction("modify")}>
                            Modify
                          </button>
                          <button onClick={() => handleAction("reject")}>
                            Reject
                          </button>
                        </div>
                      )}
                  </div>
                {/* </form> */}
              </div>
            </div>

            {/* {tableData.length > 0 && ( */}
            <TableApprover
              tableData={tableData}
              headings={[
                "Distributor Name",
                "Fund Name",
                "Invoice Month",
                "Gst Category",
                "Tds Category",
                "Fee Type",
                "Brokerage Amount",
                "Brokerage Calculation File",
                "Invoice File",
              ]}
              userId={userId}
              onRowClick={handleRowClick}
              setTableData={setTableData}
              onFileDownload={handleDownloadFile}
              setSelectedRowIds={setSelectedRowIds}
              selectedRowIds={selectedRowIds}
              curStatus={curStatus}
              setCurStatus={setCurStatus}
              statusArray={statusArray}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              totalPages={totalPages}
              filter={filter}
              setFilter={setFilter}
            />
            {/* )} */}
          </div>
        )}
      </div>
      <Footer />
      <ToastContainer
        autoClose={3000}
      />
    </>
  );
};

export default ApproverPage;